import { render, staticRenderFns } from "./EmailInputForm.vue?vue&type=template&id=5d5f5aa3&scoped=true&"
import script from "./EmailInputForm.vue?vue&type=script&lang=js&"
export * from "./EmailInputForm.vue?vue&type=script&lang=js&"
import style0 from "./EmailInputForm.vue?vue&type=style&index=0&id=5d5f5aa3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d5f5aa3",
  null
  
)

export default component.exports